module.exports = __webpack_public_path__ + "img/icon_kehu_07.d9313dbb.png";